module.exports = {"private":true,"main":"./SingleImageUpload.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/fields/SingleImageUpload/package.json
// module id = 837
// module chunks = 0 1